import { Check } from "lucide-react";
import { whyUs, waLink } from "@/content/siteContent";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export default function WhyUs() {
  return (
    <section className="bg-cream py-24 md:py-32" data-testid="why-us-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid items-start gap-12 lg:grid-cols-[1fr_1.3fr]">
          <div className="lg:sticky lg:top-28">
            <SectionHeading
              light
              chapter={whyUs.chapter}
              microtitle={whyUs.microtitle}
              titleA={whyUs.titleA}
              titleB={whyUs.titleB}
              highlightWord={whyUs.highlightWord}
            />
            <Reveal delay={0.2}>
              <a href={waLink()} target="_blank" rel="noopener noreferrer" className="btn-industrial" data-testid="why-us-cta">
                FALAR COM ESPECIALISTA
              </a>
            </Reveal>
          </div>

          <div className="card-industrial p-7 md:p-10" data-testid="why-us-panel">
            <div className="stripes mb-8 h-1.5 w-24 rounded-full" />
            <ul className="grid gap-x-8 gap-y-5 sm:grid-cols-2">
              {whyUs.items.map((item, i) => (
                <Reveal key={item} delay={i * 0.05} y={16}>
                  <li className="flex items-center gap-3 text-sm font-semibold text-paper md:text-[0.95rem]" data-testid={`why-us-item-${i + 1}`}>
                    <span className="check-industrial">
                      <Check className="h-3 w-3" strokeWidth={3} />
                    </span>
                    {item}
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
